package com.elan.edubridge.shared.domain.model

import kotlinx.serialization.Serializable

@Serializable
enum class MembershipStatus {
    /** 초대 발송됨, 수락 전 */
    INVITED,

    /** 학원장 신청 등 전체 관리자 승인 대기 */
    PENDING_APPROVAL,
    ACTIVE,
    SUSPENDED,
    REVOKED,
}

/**
 * 기획서 §3의 `academyId + userId + role + status` 멤버십.
 * Firestore `edubridge_academies/{academyId}/members/{uid}`에 대응한다.
 * 생성·변경은 Functions에서만 수행한다(§5).
 */
@Serializable
data class AcademyMembership(
    val academyId: String,
    val academyName: String,
    val userId: String,
    val role: UserRole,
    /**
     * 인가 판정의 유일한 축(§2.2). Functions가 쓰기 시점에 `PermissionPolicy.permissionFor(role)`로
     * 계산해 저장한다. 클라이언트가 보낸 값은 rules가 거부하므로 여기 있는 값은 항상 서버가 쓴 것이다.
     */
    val permission: Permission,
    val status: MembershipStatus,
    /** 선생님의 배정 반(§4.5). 출결 읽기 범위를 이 목록으로 좁힌다. Functions가 반 배정 시 갱신한다. */
    val assignedClassIds: List<String> = emptyList(),
    val invitedBy: String? = null,
    /** ISO-8601 서버 시각. kotlinx-datetime 미도입이므로 기존 모델과 같이 String을 쓴다. */
    val activatedAt: String? = null,
) {
    val isUsable: Boolean get() = status == MembershipStatus.ACTIVE
}
